/**
 * ============================================================
 * 简体中文 (Simplified Chinese)
 * ============================================================
 *
 * Translators:
 *
 * RuolinZheng08
 */

export default {
	'AdvanceHelp': '按下空格键或点击屏幕以继续',
	'AllowPlayback': '点击这里以启用语音回放',
	'Audio': '音效',
	'AutoPlay': '自动',
	'AutoPlayButton': 'Enable auto play',
	'AutoPlaySpeed': '自动播放速度',

	'Back': '后退',
	'BackButton': '后退',

	'Cancel': '取消',
	'Close': '关闭',
	'Confirm': '确定要退出吗？',
	'Credits': 'Credits',

	'Delete': '删除',
	'DialogLogButton': 'Show the dialog log',

	'FullScreen': '全屏显示',

	'Gallery': 'Gallery',

	'Help': '帮助',
	'Hide': '隐藏',
	'HideButton': '隐藏文字',

	'iOSAudioWarning': 'iOS暂不支持音效设定',

	'KeyboardShortcuts': 'Keyboard Shortcuts',

	'Language': '语言',
	'Load': '读取',
	'LoadAutoSaveSlots': '自动存储的游戏进度',
	'LoadButton': '显示读取界面',
	'Loading': '加载中',
	'LoadingMessage': '等待素材加载中',
	'LoadSlots': '存储的游戏进度',
	'LocalStorageWarning': '该浏览器暂不支持本地存储功能',
	'Log': 'Log',

	'Music': '音乐音量',

	'NoSavedGames': '没有存储的游戏进度',
	'NoAutoSavedGames': '没有自动存储的游戏进度',
	'NewContent': '有新的内容可供使用，重新加载页面以获取最新版本',
	'NoDialogsAvailable': 'No dialogs available. Dialogs will appear here as they show up',

	'OK': '確定',
	'OrientationWarning': '请将设备旋转以体验游戏内容',
	'Overwrite': '覆盖',

	'QuickButtons': '快捷菜单按钮',
	'QuickMenu': 'Quick Menu',
	'Quit': '退出',
	'QuitButton': '退出游戏',

	'Resolution': '分辨率',

	'Save': '存档',
	'SaveButton': '显示存档界面',
	'SaveInSlot': '写入存档槽位',
	'SelectYourLanguage': 'Select your language',
	'Settings': '环境设定',
	'SettingsButton': '显示环境设定界面',
	'Show': '显示',
	'Skip': 'Skip',
	'SkipButton': 'Enter skip mode',
	'SlotDeletion': '确定要删除这个存档槽位吗？',
	'SlotOverwrite': '确定要覆盖这个存档槽位吗？',
	'Sound': '音效音量',
	'Start': '开始',
	'Stop': '停止',

	'TextSpeed': '文字显示速度',

	'Video': 'Video Volume',
	'Voice': '语音音量',

	'Windowed': '窗口'
};
